// extracted by mini-css-extract-plugin
module.exports = {"container":"Conclusion_container__2-haC","text-anal":"Conclusion_text-anal__19wSa"};